import Typography from '@mui/material/Typography'
import styled from '@mui/material/styles/styled'

export const Title = styled(Typography, {
  name: 'Title',
  slot: 'Root',
  skipSx: true,
})`
  font-family: Source Sans Pro Bold;
  background-color: theme.palette.common.white;
  font-size: 16px;
  padding: 29px 0px 30px 27px;
  margin: 0;
  height: 24px;
`
